import { ReceiptTemplateType } from "src/graphql/quark/quark.type"
import OrderReceipt, { OrderReceiptDataProps } from "../order-receipt"
// import { Stack } from "src/shared/components"
import { Stack } from "@mui/material"
import ReturnOrderReceipt, { ReturnOrderReceiptDataProps } from "../return-receipt"
import { forwardRef } from "react"

const OrderDetailedReceipt = forwardRef(
  (
    {
      receiptType,
      receiptData,
      returnOrders
    }: {
      receiptType: ReceiptTemplateType
      receiptData: OrderReceiptDataProps
      returnOrders: ReturnOrderReceiptDataProps[]
    },
    ref
  ) => {
    return (
      <Stack
        ref={ref as any}
        direction="column"
        spacing={1}
        sx={{
          width: "100%",
          "@media print": { alignSelf: "flex-start !important" }
        }}
      >
        <>
          <OrderReceipt
            isHideFooter={returnOrders.length > 0}
            receiptData={{ ...receiptData, isDuplicateSlip: true }}
            receiptType={receiptType}
          />

          {returnOrders?.map((returnOrder, index) => (
            <>
              <div className="page-break" />
              <ReturnOrderReceipt
                isHideFooter={returnOrders.length - 1 === index}
                receiptData={{
                  ...returnOrder,
                  isDuplicateSlip: true
                }}
              />
            </>
          ))}
        </>
      </Stack>
    )
  }
)

export default OrderDetailedReceipt
